export const matchById = (option: any, value: any) => option.id === value.id;

export const matchByValue = (option: any, value: any) => option.value === value.value;
